/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const MenuContext = createContext();

export const useMenuContext = () => useContext(MenuContext);

// The selected section is derived from the URL (/dashboard/:section) so the
// browser back/forward buttons move between app screens and sections are
// bookmarkable. setSelectedMenuItem keeps its old signature, but navigates
// instead of setting local state; consumers don't need to know the difference.
export const MenuProvider = ({ children }) => {
  const navigate = useNavigate();
  const { section } = useParams();
  const selectedMenuItem = section || ''; // '' → welcome screen

  const setSelectedMenuItem = useCallback(
    (id) => {
      if (id === selectedMenuItem) return; // don't stack duplicate history entries
      navigate(`/dashboard/${id}`);
    },
    [navigate, selectedMenuItem]
  );

  return (
    <MenuContext.Provider value={{ selectedMenuItem, setSelectedMenuItem }}>
      {children}
    </MenuContext.Provider>
  );
};
